import { useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { useAuth } from '../store/auth'
import { Botao, Erro } from '../components/ui'
import { CampoDeSenha, mensagemDeErro } from '../components/CampoDeSenha'

/**
 * Escolher uma senha nova a partir do link do e-mail.
 *
 * Esta é a única tela do console que abre SEM login — é o ponto inteiro dela.
 * O token vem na query porque é o que um link de e-mail consegue carregar.
 *
 * Ele não é guardado em lugar nenhum: vai da URL para a chamada e some. E como
 * o Upgrade ID derruba todas as sessões ao redefinir, o fim do caminho é a
 * tela de login, não o console já aberto.
 */
export default function Redefinir() {
  const redefinir = useAuth((s) => s.redefinir)
  const [params] = useSearchParams()
  const token = params.get('token') || ''

  const [senha, setSenha] = useState('')
  const [repetida, setRepetida] = useState('')
  const [erro, setErro] = useState('')
  const [indo, setIndo] = useState(false)
  const [pronto, setPronto] = useState(false)

  async function enviar(e) {
    e.preventDefault()
    if (senha !== repetida) {
      // Conferência no navegador porque o servidor não tem como saber: ele
      // recebe uma senha só, e uma senha digitada errado duas vezes iguais
      // seria aceita. Repetir é o que pega o erro de digitação.
      setErro('As duas senhas não são iguais.')
      return
    }
    setErro(''); setIndo(true)
    try {
      await redefinir(token, senha)
      setPronto(true)
    } catch (err) {
      setErro(mensagemDeErro(err))
    } finally { setIndo(false) }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 p-6">
      <div className="flex w-full max-w-sm flex-col gap-4 rounded-xl border border-zinc-200 bg-white p-7">
        <div>
          <h1 className="text-lg font-semibold text-zinc-900">Senha nova</h1>
          <p className="text-sm text-zinc-500">Console do registro central</p>
        </div>

        {!token ? (
          <>
            <Erro>O link está incompleto — falta o código de redefinição.</Erro>
            <Link to="/esqueci" className="text-sm text-pinho-700 hover:underline">pedir um link novo</Link>
          </>
        ) : pronto ? (
          <>
            <p className="text-sm leading-relaxed text-zinc-600">
              Senha trocada. Todas as sessões abertas foram encerradas, inclusive em outros
              aparelhos.
            </p>
            <Link to="/" className="text-sm text-pinho-700 hover:underline">entrar com a senha nova</Link>
          </>
        ) : (
          <form onSubmit={enviar} className="flex flex-col gap-4">
            <CampoDeSenha valor={senha} onChange={setSenha} />
            <input
              type="password" required value={repetida} onChange={(e) => setRepetida(e.target.value)}
              placeholder="repita a senha nova" autoComplete="new-password"
              className="rounded-lg border border-zinc-300 px-3 py-2 text-sm"
            />
            <Erro>{erro}</Erro>
            <Botao type="submit" disabled={indo}>{indo ? 'salvando…' : 'Salvar'}</Botao>
          </form>
        )}
      </div>
    </div>
  )
}
